import { ColumnInterface } from "components/tables/interfaces";
import Table from "components/tables/table";
import { Admin } from "models/admin";
import { ListAdmin } from "models/list-admin";
import { Fragment, FunctionComponent, useEffect, useState } from "react";
import { adminDoGetAdmins } from "services/admin/admin";
import {
  adminDoDeleteListAdmin,
  adminDoGetListAdmins,
} from "services/admin/list-admin";
import { useAuthAdmin } from "stores/hooks/auth";
import ListAdminAddModal from "./list-admin-add-modal";
import { showError, showSuccess } from "lib/notification";
import { List } from "models/list";

interface ListAdminsTableProps {
  list: List;
}

const ListAdminsTable: FunctionComponent<ListAdminsTableProps> = ({ list }) => {
  const admin = useAuthAdmin();
  const [listAdmins, toggleListAdmins] = useState<ListAdmin[]>([]);
  const [admins, toggleAdmins] = useState<Admin[]>([]);
  const [addModal, toggleAddModal] = useState(false);

  const update = async () => {
    const admins = await adminDoGetAdmins();
    toggleAdmins(admins);

    const listAdmins = await adminDoGetListAdmins(list.uuid);
    toggleListAdmins(listAdmins);
  };

  useEffect(() => {
    update();
  }, []);

  const columns: ColumnInterface[] = [
    {
      key: "admin",
      header: "Pääsyoikeuden haltija",
      render: (listAdmin: ListAdmin) => {
        const ad = admins.find((a) => a.uuid === listAdmin.admin_uuid);
        if (ad) {
          let str = `${ad.firstname} ${ad.lastname}`;
          if (admin && admin.uuid === ad.uuid) {
            str += " [sinä]";
          }
          return str;
        }
        return "";
      },
    },
  ];

  const handleAdd = async () => toggleAddModal(true);

  const handleDelete = async (listAdmin: ListAdmin) => {
    try {
      await adminDoDeleteListAdmin(list.uuid, listAdmin.uuid);

      update();

      showSuccess("Pääsyoikeus lisääminen onnistui.");
    } catch (err) {
      showError("Pääsyoikeuden poistaminen epäonnistui.");
    }
  };

  return (
    <Fragment>
      <Table
        name={`list-${list.uuid}-list-admins`}
        columns={columns}
        data={listAdmins}
        adder={{
          text: "Lisää pääsyoikeus",
          onClick: handleAdd,
          isDisabled: () => listAdmins.length === admins.length,
        }}
        deleter={{
          onClick: handleDelete,
          isDisabled: (listAdmin: ListAdmin) =>
            listAdmin.admin_uuid === admin?.uuid,
        }}
      />
      {addModal && (
        <ListAdminAddModal
          listUuid={list.uuid}
          admins={admins}
          listAdmins={listAdmins}
          onUpdate={update}
          onClose={async () => toggleAddModal(false)}
        />
      )}
    </Fragment>
  );
};

export default ListAdminsTable;
